module.exports = __webpack_public_path__ + "static/media/louBg.b2f6acfc.jpg";